import { requireAdminOrManager } from '@/lib/auth/guards';
import type { AppUser } from '@/lib/auth/user';
import { getSiteSettings, updateSiteSettings } from '@/lib/supabase/siteSettings';
import type { SiteSettings, SiteSettingsUpdateInput } from '@/lib/types/siteSettings';

export async function fetchSiteSettings({
  signal,
}: {
  signal?: AbortSignal;
} = {}): Promise<SiteSettings> {
  return getSiteSettings({ signal });
}

export async function updateSiteSettingsForUser({
  user,
  values,
  signal,
}: {
  user: AppUser | null;
  values: SiteSettingsUpdateInput;
  signal?: AbortSignal;
}): Promise<SiteSettings> {
  const actor = requireAdminOrManager(user);
  void actor;

  return updateSiteSettings({ values, signal });
}
